import { useGaugeState } from "@mui/x-charts/Gauge";
import { alpha, PaletteColor, useTheme } from "@mui/material";
import { VALUE_ANGLE_OFFSET } from "~/pages/space/home-dashboard/SpaceOrWorkspaceRiskCard/components/SpaceRiskGaugeChart/utils/spaceRiskGaugeChartUtils";

const SpaceRiskGaugeChartSubArc = () => {
  const { startAngle, endAngle, outerRadius, cx, cy } = useGaugeState();
  const theme = useTheme();
  const mainArcStrokeWidth = 19;
  const subArcStrokeWidth = 10;
  const spaceBetweenArcs = 8;
  const width = `${100 - VALUE_ANGLE_OFFSET}%`;

  const innerRadius =
    outerRadius -
    mainArcStrokeWidth / 2 -
    subArcStrokeWidth / 2 -
    spaceBetweenArcs;

  const segments = 5;
  const gapDegrees = 3;
  const gapRadians = (gapDegrees * Math.PI) / 180;

  const totalAngle = endAngle - startAngle;
  const segmentAngle = (totalAngle - segments * gapRadians) / segments;

  const segmentColors: Array<keyof typeof theme.palette> = [
    "none",
    "low",
    "medium",
    "high",
    "critical",
  ];

  const paths = [];

  for (let i = 0; i < segments; i++) {
    const start = startAngle + i * (segmentAngle + gapRadians);
    const end = start + segmentAngle;

    const startX = cx + innerRadius * Math.sin(start);
    const startY = cy - innerRadius * Math.cos(start);
    const endX = cx + innerRadius * Math.sin(end);
    const endY = cy - innerRadius * Math.cos(end);

    const largeArcFlag = segmentAngle > Math.PI ? 1 : 0;

    const d = `
      M ${startX} ${startY}
      A ${innerRadius} ${innerRadius} 0 ${largeArcFlag} 1 ${endX} ${endY}
    `;

    const colorTune = segmentColors[i];

    paths.push(
      <path
        key={i}
        d={d}
        stroke={alpha((theme.palette[colorTune] as PaletteColor).light, 0.2)}
        strokeWidth={subArcStrokeWidth}
        fill="none"
        strokeLinecap="butt"
      />,
    );
  }

  return (
    <svg
      width={width}
      height="100%"
      viewBox={`0 0 ${outerRadius * 2} ${outerRadius * 2}`}
    >
      {paths}
    </svg>
  );
};

export default SpaceRiskGaugeChartSubArc;
